import { render, staticRenderFns } from "./OrganiserWizard.vue?vue&type=template&id=20646c00&scoped=true&lang=pug"
import script from "./OrganiserWizard.vue?vue&type=script&lang=js"
export * from "./OrganiserWizard.vue?vue&type=script&lang=js"
import style0 from "./OrganiserWizard.vue?vue&type=style&index=0&id=20646c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20646c00",
  null
  
)

export default component.exports